module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAJCAYAAAARml2dAAAAhklEQVQImV3PIQ9BUQDF8d8V2N6G2RSBQtHeB1IkmxnBNzGK5oP4DF7yihtUSaVcxd3Mif8T/ueElJKcWFctLPBu/MA2tpjgHFJKYl31sUGB3Xha3sPtehlijdcXPqCBGTo4ZpiLE55Yxroa5CI7el9HF/vxtIwhz411VWCFEQ7h70cTc6QPUb41ZeqAUMkAAAAASUVORK5CYII="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/arrow.png
 ** module id = 174
 ** module chunks = 0
 **/